<template>
  <div class="w-full flex flex-col text-center">
    <FileUploadButton v-if="!hideButtons" v-model:file="file" accept=".xls,.xlsx" class="mx-auto"></FileUploadButton>
    <Fieldset legend="Spreadsheet Info" pt:content:class="py-0!">
      <div class="flex flex-row justify-evenly items-center">
        <div class="flex flex-col items-end gap-2">
          <div class="flex flex-row">
            <p class="font-bold my-auto">Tab #</p>
            <InputNumber
              v-model="importData.tab"
              showButtons
              increment-button-class="py-0! w-full"
              decrement-button-class="py-0! w-full"
              :min="1"
              class="h-10 ml-3"
              inputClass="w-16 pe-0"
              :allowEmpty="false"
              :disabled="file == null ? false : file.name.endsWith('.csv')"
              pt:buttonGroup:class="w-6!"
            ></InputNumber>
          </div>
          <div class="flex flex-row">
            <p class="font-bold my-auto">Inspector Comments Row</p>
            <InputNumber
              v-model="importData.commentsRow"
              showButtons
              :min="1"
              increment-button-class="py-0! w-full"
              decrement-button-class="py-0! w-full"
              class="h-10 ml-3"
              inputClass="w-16 pe-0"
              :allowEmpty="false"
              pt:buttonGroup:class="w-6!"
            ></InputNumber>
          </div>
        </div>
        <div class="flex flex-col items-end gap-2">
          <div class="flex flex-row">
            <p class="font-bold my-auto">Budget Start Row</p>
            <InputNumber
              v-model="importData.startRow"
              showButtons
              :min="1"
              increment-button-class="py-0! w-full"
              decrement-button-class="py-0! w-full"
              class="h-10 ml-3"
              inputClass="w-16 pe-0"
              :allowEmpty="false"
              pt:buttonGroup:class="w-6!"
            ></InputNumber>
          </div>
          <div class="flex flex-row">
            <p class="font-bold my-auto">Budget End Row</p>
            <InputNumber
              v-model="importData.endRow"
              showButtons
              :min="1"
              increment-button-class="py-0! w-full"
              decrement-button-class="py-0! w-full"
              class="h-10 ml-3"
              inputClass="w-16 pe-0"
              :allowEmpty="false"
              pt:buttonGroup:class="w-6!"
            ></InputNumber>
          </div>
        </div>
      </div>
    </Fieldset>
    <Fieldset legend="Column Info" pt:content:class="py-0!">
      <div class="flex flex-row">
        <div class="flex flex-col w-2/5 text-end text-sm">
          <ImportColumnPicker v-model:column="lineRefCol" :columns label="Line Ref # Column"></ImportColumnPicker>
          <ImportColumnPicker v-model:column="inspectionCol" :columns label="Inspection Column"></ImportColumnPicker>
          <ImportColumnPicker v-model:column="commentsCol" :columns label="Inspector Comments Column"></ImportColumnPicker>
        </div>
      </div>
    </Fieldset>
  </div>
  <div class="flex mt-2 justify-end">
    <SubmitButton v-if="!hideButtons" label="Import" class="ml-auto" icon="file-import" @click="importInspection"></SubmitButton>
  </div>
</template>

<script setup lang="ts">
import SubmitButton from "@/components/global/buttons/SubmitButton.vue";
import { convertImportColumnToIndex } from "@/services/Utility";

interface Props {
  drawId: string;
  hideButtons?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  hideButtons: false,
});

const emit = defineEmits<{
  importComplete: [];
}>();

//Was having an issue with display the name without having it as a separate ref, I hate this code
const file = ref<File | null>(null);

const lineRefCol = ref("");
const inspectionCol = ref("");
const commentsCol = ref("");

const importData = ref({
  tab: 1,
  startRow: 1,
  endRow: 1,
  commentsRow: 1,
  lineRefCol: 2,
  inspectionCol: 25,
  commentsCol: 2,
  file: new File([""], ""),
});

const columns = " ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

const importInspection = async (): Promise<void> => {
  if (file.value == null) {
    error("File Missing", "An import file has not been selected");
    return;
  }
  if (importData.value.startRow > importData.value.endRow) {
    error("Invalid Value", "Start row may not be greater than the end row");
    return;
  }

  importData.value.lineRefCol = convertImportColumnToIndex(lineRefCol);
  importData.value.inspectionCol = convertImportColumnToIndex(inspectionCol);
  importData.value.commentsCol = convertImportColumnToIndex(commentsCol);
  importData.value.file = file.value;

  await axios
    .post(`/draw/${props.drawId}/inspection/import`, importData.value, { headers: { "Content-Type": "multipart/form-data" } })
    .then((response) => {
      handleApiResponse(
        response,
        (data: any) => {
          emit("importComplete");
        },
        (errorlist: ApiError[]) => {
          for (let e of errorlist) {
            error("Import Error", e.message, 10000);
          }
        }
      );
    })
    .catch((e) => errorApi(e));
};
</script>
